import IPadAppStoreBadgeIcon from "../../assets/images/ipad-app-store-badge.svg";
import { useTracker } from "../../hooks/useTracker";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const IPadButton: React.FC<{ downloadURL: string; preferred: boolean }> = ({
  downloadURL,
  preferred,
}) => {
  const tracker = useTracker();

  return (
    <div className={`${style.cell} ${style.ipad} ${preferred ? style.preferred : ""}`}>
      <div>
        <a
          target="_blank"
          rel="noreferrer noopener"
          className={style.button}
          href={downloadURL}
          onClick={() => {
            tracker.trackButtonClick({ elementId: "download-ipad" });
          }}
          title="Download for iPadOS"
        >
          <img src={IPadAppStoreBadgeIcon} alt="iPad App Store Icon" />
        </a>
      </div>
      <div className={style.buttonDescription}>
        <span>Requires iPadOS 15 or later — preferably with Apple Pencil</span>
        <div>
          <a
            rel="noreferrer noopener"
            href="https://www.shapr3d.com/compatible-devices#ipad"
            target="_blank"
          >
            See compatible iPads
          </a>
        </div>
      </div>
    </div>
  );
};

export default IPadButton;
